import AsyncComponent from '../../components/HOC/AsyncComponent';

const AsyncMovements = AsyncComponent(() => import('./Movements'));
const AsyncMovementsSummary = AsyncComponent(() =>
  import('./MovementsSummary')
);
const AsyncBankAccounts = AsyncComponent(() => import('./BankAccounts'));
const AsyncBankAccount = AsyncComponent(() => import('./BankAccount'));

export {
  AsyncMovements,
  AsyncMovementsSummary,
  AsyncBankAccounts,
  AsyncBankAccount,
};



// WEBPACK FOOTER //
// ./src/pages/InOutBalance/index.js